import { render, staticRenderFns } from "./DigitalProcessSolutions.vue?vue&type=template&id=d453f62c&scoped=true"
import script from "./DigitalProcessSolutions.vue?vue&type=script&lang=js"
export * from "./DigitalProcessSolutions.vue?vue&type=script&lang=js"
import style0 from "./DigitalProcessSolutions.vue?vue&type=style&index=0&id=d453f62c&prod&lang=scss&scoped=true"
import style1 from "./DigitalProcessSolutions.vue?vue&type=style&index=1&id=d453f62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d453f62c",
  null
  
)

export default component.exports